import React, { Component } from 'react';

import { Button, Table, Tag, Col } from 'antd/lib';
import moment from 'moment';

class MostrarEvaluacion extends Component {
  render() {
    if (!this.props.evaluacion) {
      return (
        <div>
          <h2> Evaluacion de la Victima </h2>
          <Col span={8} offset={8}>
            <h4>SIN EVALUACION ACTUALMENTE</h4>
          </Col>
          <Col span={4}>
            <Button
              type="primary"
              onClick={() =>
                this.props.history.push(
                  `/violenciaGenero/caso/${
                    this.props.match.params.id
                  }/registrarEvaluacion`
                )
              }
            >
              Realizar Evaluacion
            </Button>
          </Col>
          <br />
        </div>
      );
    }

    let { evaluacion } = this.props;

    const columns = [
      {
        title: 'Fecha Evaluacion',
        dataIndex: 'fecha',
        key: 'fecha',
        render: fecha => moment(fecha).format('DD/MM/YYYY'),
      },
      {
        title: 'Coeficiente de Riesgo',
        dataIndex: 'valor',
        key: 'valor',
      },
      {
        title: 'Riesgo',
        key: 'riesgo',
        render: evaluacion => {
          let respuesta = null;
          let valor = evaluacion.valor;
          switch (true) {
            case valor >= 5 && valor < 15:
              respuesta = (
                <span>
                  <Tag color="#1ed300">BAJO</Tag>
                </span>
              );
              break;
            case valor >= 15 && valor < 25:
              respuesta = (
                <span>
                  <Tag color="#98af00">MODERADO</Tag>
                </span>
              );
              break;
            case valor >= 25 && valor < 30:
              respuesta = (
                <span>
                  <Tag color="#b78300">MEDIO</Tag>
                </span>
              );
              break;
            case valor >= 30 && valor < 40:
              respuesta = (
                <span>
                  <Tag color="#e07904">ALTO</Tag>
                </span>
              );
              break;
            case valor >= 40:
              respuesta = (
                <span>
                  <Tag color="#e03004">ALTISIMO</Tag>
                </span>
              );
              break;
            default:
              respuesta = (
                <span>
                  <Tag color="#0f7000">SIN RIESGO</Tag>
                </span>
              );
              break;
          }

          return respuesta;
        },
      },
      {
        title: 'Acciones',
        key: 'action',
        // eslint-disable-next-line no-unused-vars
        render: (text, record) => (
          <Button type="primary" disabled={true}>
            VER
          </Button>
        ),
      },
    ];

    return (
      <div>
        <h2> Evaluacion de la Victima </h2>
        <Table
          pagination={false}
          columns={columns}
          rowKey="_id"
          dataSource={[evaluacion]}
        />
      </div>
    );
  }
}

export default MostrarEvaluacion;
